import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { usePageData } from "../PageData";
import { getBannerTargetWindow } from "../data/sport-utils";
import { byRanking, getConfiguration } from "../data/utils";
import { systemCode } from "..";

// import { useNavigate } from "react-router-dom";

function handleOpenBanner(banner) {
  if (banner.avvData) {
    banner.avvData.openedFromBanner = true;
    localStorage.setItem("land-from-banner", JSON.stringify(banner.avvData));
  }
  window.open(banner.url, getBannerTargetWindow(banner.url));
}

export const SwiperCarousel = ({ banners }) => {
  const conf = getConfiguration();

  const pagination = {
    clickable: true,
    renderBullet: function (index, className) {
      return (
        '<span class="' +
        className +
        '">' +
        // ModelCarousel[index].title +
        banners[index].text +
        "</span>"
      );
    },
  };

  return (
    <>
      {banners && (
        <Swiper
          pagination={pagination}
          navigation={conf.iwh && systemCode !== 'SUREBET' ? false : true}
          modules={[Pagination, Autoplay, Navigation]}
          autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
          className="swiper__carousel"
        >
          {banners.sort(byRanking).map((i, index) => (
            <SwiperSlide onClick={() => null} key={i.id}>
              <img
                alt={i.text}
                src={i.imageUrl}
                onClick={() => handleOpenBanner(banners[index])}
              />
              {/* <div className="swiper__working">
                Swiper working, N°: {index}{" "}
              </div> */}
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </>
  );
};

export default SwiperCarousel;
